import { UserGoal } from '@/models/user.model';
import { BaseService, Status, DataResponse } from './base.service';

class UserGoalService extends BaseService {
  private url: string = '/api/user-goal';

  constructor() {
    super();
  }

  public async getUserGoals(id: number): Promise<DataResponse<UserGoal[]>> {
    const res = await this.$http.get<UserGoal[]>(`${this.url}/by-user/${id}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async deleteUserGoal(id: number): Promise<unknown> {
    const res = await this.$http.delete<UserGoal[]>(`${this.url}/${id}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }
}

export default new UserGoalService();
